import React, { ReactElement, useEffect } from 'react';
import { Link } from 'react-router-dom'
import logo from '../../assets/img/logotipo.svg'
import paths from '../../config/paths'
import { API_VERSION } from '../../utils/constants';
import addressBook from '../../assets/img/address-list.svg';
import wooCommerce from '../../assets/img/wooCommerce.svg';
import recharge from '../../assets/img/recharge.svg';
import history from '../../assets/img/history.svg';

interface SidebarProps {
  children?: any
  history?: any;
  links?: any;
  actions?: any;
  smallMenu: boolean;
  profile: any;
}

interface MenuItem {
  name: string,
  path: string,
  submenus?: MenuItem[]
  svg: JSX.Element;

}

const menuItemsBase: MenuItem[] = [
  {
    name: 'Dashboard',
    submenus: [],
    path: paths.DASHBOARD,
    svg: (
      <svg className="w-8 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 224.036 209.763">
        <g id="Grupo_5483" data-name="Grupo 5483" transform="translate(-2179.5 -1889)">
          <path id="Trazado_7570" data-name="Trazado 7570" d="M2403.536,1995.1h-16.323v-84.064h-64.477V1995.1h-31.83v-18.772a37.606,37.606,0,0,0-28.491-36.433,26.164,26.164,0,0,0,17.85-23.554H2298.4v-2.448h-18.131a26.116,26.116,0,1,0-34.984,25.778,37.6,37.6,0,0,0-29.461,36.658V1995.1h-15.507v27.838H2179.5v75.824h198.932v-21.23h25.1Zm-54.683-81.616H2361.1v9.794h-12.242Zm-2.448,0v12.242h17.139v-12.242h21.22V1954.7h-59.58v-41.216Zm2.448,43.665H2361.1v10.2h-12.242Zm-23.669,0h21.22V1969.8h17.139v-12.651h21.22V1995.1h-59.58Zm-36.727,19.18V1995.1h-33.871v-53.836A35.131,35.131,0,0,1,2288.458,1976.329Zm-34.279-84.881a23.7,23.7,0,0,1,23.637,22.444h-47.273A23.7,23.7,0,0,1,2254.179,1891.448Zm-23.637,24.893h47.273a23.668,23.668,0,0,1-47.273,0Zm-12.274,59.988a35.131,35.131,0,0,1,33.871-35.064V1995.1h-33.871Zm182.82,98.755H2202.761v-77.535h198.327Z" fill="#fff" />
          <rect id="Rectángulo_504" data-name="Rectángulo 504" width="13.059" height="2.448" transform="translate(2232.551 1966.943)" fill="#fff" />
          <rect id="Rectángulo_505" data-name="Rectángulo 505" width="13.059" height="2.448" transform="translate(2263.972 1967.351)" fill="#fff" />
        </g>
      </svg>
    )
  },
  {
    name: 'Recarga créditos',
    submenus: [],
    path: paths.RECHARGE_CREDITS,
    svg: (
      <img src={recharge} width="35" alt="" />
    )
  },
  {
    name: 'Movimientos',
    submenus: [],
    path: paths.TRANSACTION_HISTORY,
    svg: (
      <img src={history} width="35" className="mr-2 filter" alt="" />
    )
  },
  {
    name: 'Cotizador',
    submenus: [],
    path: paths.QUOTE,
    svg: (
      <svg className="w-8 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 105.575 87.643">
        <g id="Grupo_5526" data-name="Grupo 5526" transform="translate(0)">
          <path id="Trazado_7624" data-name="Trazado 7624" d="M3540.346,1116h-34.027l-18.949-12.886a.87.87,0,0,0-.94-.023l-9.711,5.909-8.185-5.906-33.764,20.332.379,43.459,35.83,23.723,8.471-6.333,5.923,3.9a.869.869,0,0,0,.945.007l29.311-18.775-.012-.018h24.727Zm-53.49-11.135L3503.23,1116h-4.988v31.767l-12,7.675-39.14-26.391Zm-40.511,25.768,39.014,26.305-.356,28.914-39.022-25.7Zm40.395,55.217.356-28.891,11.147-7.132v19.561h14.2Zm51.87-18.2h-38.631V1117.74h38.631Z" transform="translate(-3434.771 -1102.969)" fill="#fff" />
          <path id="Trazado_7625" data-name="Trazado 7625" d="M3591.868,1164.1h30.818a.869.869,0,0,0,.868-.868v-17.362a.869.869,0,0,0-.868-.868h-30.818a.868.868,0,0,0-.868.868v17.362A.868.868,0,0,0,3591.868,1164.1Zm.868-17.362h29.082v15.626h-29.082Z" transform="translate(-3523.187 -1126.756)" fill="#fff" />
          <rect id="Rectángulo_507" data-name="Rectángulo 507" width="7.204" height="1.736" transform="translate(68.681 41.809)" fill="#fff" />
          <rect id="Rectángulo_508" data-name="Rectángulo 508" width="7.204" height="1.736" transform="translate(80.4 41.809)" fill="#fff" />
          <rect id="Rectángulo_509" data-name="Rectángulo 509" width="7.204" height="1.736" transform="translate(92.12 41.809)" fill="#fff" />
          <rect id="Rectángulo_510" data-name="Rectángulo 510" width="7.204" height="1.736" transform="translate(68.681 47.451)" fill="#fff" />
          <rect id="Rectángulo_511" data-name="Rectángulo 511" width="7.204" height="1.736" transform="translate(80.4 47.451)" fill="#fff" />
          <rect id="Rectángulo_512" data-name="Rectángulo 512" width="7.204" height="1.736" transform="translate(92.12 47.451)" fill="#fff" />
          <rect id="Rectángulo_513" data-name="Rectángulo 513" width="7.204" height="1.736" transform="translate(68.681 53.094)" fill="#fff" />
          <rect id="Rectángulo_514" data-name="Rectángulo 514" width="30.818" height="1.736" transform="translate(68.681 58.737)" fill="#fff" />
          <rect id="Rectángulo_515" data-name="Rectángulo 515" width="7.204" height="1.736" transform="translate(80.4 53.094)" fill="#fff" />
          <rect id="Rectángulo_516" data-name="Rectángulo 516" width="7.204" height="1.736" transform="translate(92.12 53.094)" fill="#fff" />
        </g>
      </svg>

    )
  },
  {
    name: 'Recolecciones',
    submenus: [],
    path: paths.SCHEDULE_PICKUP,
    svg: (
      <svg className='mr-2' fill="#FFFFFF" height="30px" width="30px" version="1.1" id="Capa_1" viewBox="0 0 297 297">
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
          <path d="M283.52,143.802l-20.533-10.264l-9.382-37.524c-4.531-18.125-20.743-30.784-39.426-30.784h-41.217 c-5.458,0-9.884,4.425-9.884,9.884v6.424h-22.979v-39.04c0-5.458-4.425-9.884-9.884-9.884H64.984c-5.458,0-9.884,4.425-9.884,9.884 v39.04H32.369c-5.458,0-9.884,4.425-9.884,9.884v55.348H9.884c-5.458,0-9.884,4.425-9.884,9.884v65.231 c0,5.458,4.425,9.884,9.884,9.884h7.597c4.468,18.681,21.296,32.616,41.327,32.616s36.858-13.934,41.327-32.616h80.425 c4.468,18.681,21.296,32.616,41.327,32.616s36.858-13.934,41.327-32.616h9.409c13.443,0,24.38-10.937,24.38-24.379v-41.781 C297,156.314,291.835,147.959,283.52,143.802z M182.845,84.998h31.334c9.596,0,17.923,6.502,20.25,15.811l7.414,29.653h-58.997 V84.998z M163.078,146.77h-55.595v-45.464h55.595V146.77z M74.868,52.383h45.464v29.156H74.868V52.383z M42.252,101.306h45.464 v45.464H42.252V101.306z M58.807,244.617c-12.535,0-22.732-10.197-22.732-22.732s10.197-22.732,22.732-22.732 s22.732,10.197,22.732,22.732S71.342,244.617,58.807,244.617z M58.807,179.386c-17.477,0-32.52,10.608-39.04,25.721v-38.569h143.311 v45.464h-62.945C95.665,193.32,78.838,179.386,58.807,179.386z M221.885,244.617c-12.535,0-22.732-10.197-22.732-22.732 s10.197-22.732,22.732-22.732s22.732,10.197,22.732,22.732S234.42,244.617,221.885,244.617z M277.233,207.39 c0,2.543-2.069,4.612-4.613,4.612h-9.409c-4.468-18.681-21.296-32.616-41.327-32.616c-17.477,0-32.52,10.608-39.04,25.721V150.23 h69.324l22.512,11.253c1.573,0.787,2.551,2.368,2.551,4.126V207.39z"></path>
        </g>
      </svg>
    ),
  },
  {
    name: 'Ordenes',
    submenus: [],
    path: paths.SHIPMENTS,
    svg: (
      <svg className="w-8 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 169.5 243.358">
        <g id="Grupo_5482" data-name="Grupo 5482" transform="translate(-2242.5 -1399.995)">
          <path id="Trazado_7562" data-name="Trazado 7562" d="M2412,1500.857l-78.707-38.534-77.879,39.625v15.4l-12.914,9.691v90.4l77.486,37.936,75.438-36.87v-16.974l16.576-7.664Zm-129.143,16.021,18.032,8.826.622-1.274v34.215l-18.655-8.573Zm1.512-1.956,74.367-37.445,16.566,8.11-73.429,38.107.081-.166Zm48.945-49.891,22.692,11.109-74.367,37.446-22.3-10.916Zm.8,162.181V1540.7l25.159-12.579-1.083-2.166-25.273,12.637-16.4-8.591-1.124,2.145,16.3,8.539V1626.8l-73.854-35.546v-86.621l22.6,11.062v35.932l23.5,10.8v-37.071l74.073-38.441,30.042,14.708L2370.3,1520.3l1.074,2.171,38.206-18.911v88.754Z" transform="translate(0 -12.02)" fill="#fff" />
          <rect id="Rectángulo_499" data-name="Rectángulo 499" width="38.286" height="2.422" transform="translate(2353.154 1449.16) rotate(-43.681)" fill="#fff" />
          <rect id="Rectángulo_500" data-name="Rectángulo 500" width="2.421" height="39.133" transform="matrix(1, -0.004, 0.004, 1, 2334.111, 1400.003)" fill="#fff" />
          <rect id="Rectángulo_501" data-name="Rectángulo 501" width="2.421" height="33.397" transform="translate(2285.28 1423.969) rotate(-44.747)" fill="#fff" />
        </g>
      </svg>
    )
  },
  {
    name: 'Libreta de direcciones',
    submenus: [],
    path: paths.ADDRESS_BOOK,
    svg: (
      <img src={addressBook} width="35" alt="" />
    )
  },
]

const invoiceMenuItem = {
  name: 'Facturación',
  submenus: [],
  path: paths.INVOICES,
  svg: (
  <svg
      className='w-8 mr-2'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.55281 1.60553C7.10941 1.32725 7.77344 1 9 1C10.2265 1 10.8906 1.32722 11.4472 1.6055L11.4631 1.61347C11.8987 1.83131 12.2359 1.99991 13 1.99993C14.2371 1.99998 14.9698 1.53871 15.2141 1.35512C15.5944 1.06932 16.0437 1.09342 16.3539 1.2369C16.6681 1.38223 17 1.72899 17 2.24148L17 13H20C21.6562 13 23 14.3415 23 15.999V19C23 19.925 22.7659 20.6852 22.3633 21.2891C21.9649 21.8867 21.4408 22.2726 20.9472 22.5194C20.4575 22.7643 19.9799 22.8817 19.6331 22.9395C19.4249 22.9742 19.2116 23.0004 19 23H5C4.07502 23 3.3148 22.7659 2.71092 22.3633C2.11331 21.9649 1.72739 21.4408 1.48057 20.9472C1.23572 20.4575 1.11827 19.9799 1.06048 19.6332C1.03119 19.4574 1.01616 19.3088 1.0084 19.2002C1.00194 19.1097 1.00003 19.0561 1 19V2.24146C1 1.72899 1.33184 1.38223 1.64606 1.2369C1.95628 1.09341 2.40561 1.06931 2.78589 1.35509C3.03019 1.53868 3.76289 1.99993 5 1.99993C5.76415 1.99993 6.10128 1.83134 6.53688 1.6135L6.55281 1.60553ZM3.00332 19L3 3.68371C3.54018 3.86577 4.20732 3.99993 5 3.99993C6.22656 3.99993 6.89059 3.67269 7.44719 3.39441L7.46312 3.38644C7.89872 3.1686 8.23585 3 9 3C9.76417 3 10.1013 3.16859 10.5369 3.38643L10.5528 3.39439C11.1094 3.67266 11.7734 3.9999 13 3.99993C13.7927 3.99996 14.4598 3.86581 15 3.68373V19C15 19.783 15.1678 20.448 15.4635 21H5C4.42498 21 4.0602 20.8591 3.82033 20.6992C3.57419 20.5351 3.39761 20.3092 3.26943 20.0528C3.13928 19.7925 3.06923 19.5201 3.03327 19.3044C3.01637 19.2029 3.00612 19.1024 3.00332 19ZM19.3044 20.9667C19.5201 20.9308 19.7925 20.8607 20.0528 20.7306C20.3092 20.6024 20.5351 20.4258 20.6992 20.1797C20.8591 19.9398 21 19.575 21 19V15.999C21 15.4474 20.5529 15 20 15H17L17 19C17 19.575 17.1409 19.9398 17.3008 20.1797C17.4649 20.4258 17.6908 20.6024 17.9472 20.7306C18.2075 20.8607 18.4799 20.9308 18.6957 20.9667C18.8012 20.9843 18.8869 20.9927 18.9423 20.9967C19.0629 21.0053 19.1857 20.9865 19.3044 20.9667Z'
        fill='#FFFFFF'
        stroke='#000000'
        strokeWidth='1'
      />
      <path
        d='M5 8C5 7.44772 5.44772 7 6 7H12C12.5523 7 13 7.44772 13 8C13 8.55229 12.5523 9 12 9H6C5.44772 9 5 8.55229 5 8Z'
        fill='#FFFFFF'
        stroke='#000000'
        strokeWidth='1'
      />
      <path
        d='M5 12C5 11.4477 5.44772 11 6 11H12C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13H6C5.44772 13 5 12.5523 5 12Z'
        fill='#FFFFFF'
        stroke='#000000'
        strokeWidth='1'
      />
      <path
        d='M5 16C5 15.4477 5.44772 15 6 15H12C12.5523 15 13 15.4477 13 16C13 16.5523 12.5523 17 12 17H6C5.44772 17 5 16.5523 5 16Z'
        fill='#FFFFFF'
        stroke='#000000'
        strokeWidth='1'
      />
    </svg>
  ),
};

const shopifyMenuItem = {
  name: 'Shopify (Beta)',
  submenus: [],
  path: paths.SHOP,
  svg: (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 mr-2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
    </svg>

  )
}

const wooCommerceMenuItem =  {
  name: 'Woo Commerce',
  submenus: [],
  path: paths.WOOCOMMERCE,
  svg: (
    <svg width="40px" height="40px" viewBox="0 -51.5 256 256" version="1.1" preserveAspectRatio="xMidYMid" fill="#000000" className="w-6 h-6 mr-2">

    <g id="SVGRepo_bgCarrier" strokeWidth="0"/>
    
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"/>
    
    <g id="SVGRepo_iconCarrier"> <g fill-rule="evenodd"> <path d="M232.137523,0 L23.7592719,0 C10.5720702,0 -0.103257595,10.7799647 0.000639559736,23.862498 L0.000639559736,103.404247 C0.000639559736,116.591115 10.6767385,127.266612 23.8639402,127.266612 L122.558181,127.266612 L167.667206,152.384995 L157.410382,127.266612 L232.137523,127.266612 C245.325059,127.266612 255.999888,116.591115 255.999888,103.404247 L255.999888,23.862498 C255.999888,10.6752964 245.325059,0 232.137523,0 Z M19.3640061,18.4201481 C16.4334946,18.6294847 14.2355942,19.6761007 12.7703719,21.6645976 C11.3051496,23.5484931 10.781875,25.9556632 11.095813,28.6768382 C17.2707741,67.9247058 23.027062,94.4034429 28.3647436,108.113986 C30.4579757,113.137395 32.8651458,115.5451 35.690989,115.335764 C40.086656,115.021425 45.3196694,108.951332 51.4946305,97.1248185 C54.73908,90.4260478 59.7628237,80.3792294 66.5657276,66.9823567 C72.2170797,86.762992 79.9618646,101.625221 89.6956814,111.567705 C92.417057,114.393415 95.2427665,115.649434 97.9634733,115.440098 C100.371178,115.230761 102.254539,113.974742 103.510558,111.672039 C104.557241,109.683676 104.975914,107.380974 104.766578,104.764601 C104.138568,95.2407893 105.080917,81.9489193 107.69729,64.8892584 C110.417997,47.3063898 113.767382,34.6424627 117.849111,27.1069476 C118.686458,25.5370569 119.000128,23.9670994 118.895794,22.0832708 C118.686458,19.6760338 117.639775,17.6875369 115.651411,16.1176463 C113.663048,14.5477557 111.46468,13.8151445 109.057643,14.0244142 C106.022597,14.2337508 103.719895,15.6989731 102.150205,18.6294847 C95.6614396,30.4560654 91.0560348,49.6088916 88.335328,76.1924977 C84.3579328,66.145211 81.0085475,54.3185634 78.3921746,40.3987506 C77.2411578,34.2238564 74.4154483,31.2933449 69.8100434,31.6073497 C66.670329,31.8166194 64.0538892,33.9098515 61.9606572,37.8869122 L39.0401069,81.5302462 C35.2723159,66.3544807 31.7138615,47.8296643 28.4694119,25.9556632 C27.7368007,20.5133802 24.7016209,18.0014749 19.3640061,18.4201481 Z M221.044022,25.9559976 C228.475136,27.5259551 234.022221,31.5030159 237.789611,38.0965832 C241.138996,43.7482697 242.81302,50.5511737 242.81302,58.7146317 C242.81302,69.4943957 240.092314,79.3325464 234.649562,88.3333508 C228.370134,98.7995112 220.206676,104.032257 210.054854,104.032257 C208.275828,104.032257 206.391799,103.82292 204.402767,103.404247 C196.972321,101.834557 191.425236,97.857831 187.657177,91.264063 C184.308461,85.5076413 182.633768,78.6002028 182.633768,70.5410787 C182.633768,59.7612478 185.355144,49.923164 190.797226,41.0270948 C197.181658,30.5610681 205.345116,25.3280548 215.392603,25.3280548 C217.171629,25.3280548 219.055659,25.5373913 221.044022,25.9559976 Z M216.648622,82.5769291 C220.521015,79.1232099 223.137388,73.9947979 224.602744,67.0873594 C225.021417,64.6802562 225.335087,62.0637496 225.335087,59.3425746 C225.335087,56.3074616 224.707078,53.0630121 223.451058,49.8184957 C221.881368,45.7367667 219.788002,43.5389332 217.275963,43.0155917 C213.508574,42.2829805 209.845518,44.3762126 206.391799,49.5045577 C203.566089,53.4816184 201.786394,57.6680157 200.844713,61.9590813 C200.321038,64.3663182 200.111701,66.9830255 200.111701,69.5993984 C200.111701,72.6344445 200.739711,75.8788272 201.99573,79.1232099 C203.566089,83.2049389 205.658786,85.4026386 208.170825,85.9263145 C210.787198,86.4493215 213.612908,85.2983047 216.648622,82.5769291 Z M172.167608,38.0965832 C168.399549,31.5030159 162.74813,27.5259551 155.422019,25.9559976 C153.432987,25.5373913 151.549626,25.3280548 149.769931,25.3280548 C139.723112,25.3280548 131.559654,30.5610681 125.175223,41.0270948 C119.732472,49.923164 117.011765,59.7612478 117.011765,70.5410787 C117.011765,78.6002028 118.686458,85.5076413 122.035174,91.264063 C125.803233,97.857831 131.350318,101.834557 138.780763,103.404247 C140.769126,103.82292 142.653156,104.032257 144.432851,104.032257 C154.584672,104.032257 162.74813,98.7995112 169.027559,88.3333508 C174.47031,79.3325464 177.191017,69.4943957 177.191017,58.7146317 C177.191017,50.5511737 175.516324,43.7482697 172.167608,38.0965832 Z M158.980072,67.0873594 C157.515384,73.9947979 154.898343,79.1232099 151.02595,82.5769291 C147.990904,85.2983047 145.165195,86.4493215 142.548822,85.9263145 C140.036783,85.4026386 137.943417,83.2049389 136.373727,79.1232099 C135.117707,75.8788272 134.489698,72.6344445 134.489698,69.5993984 C134.489698,66.9830255 134.699034,64.3663182 135.22271,61.9590813 C136.16439,57.6680157 137.943417,53.4816184 140.769126,49.5045577 C144.223514,44.3762126 147.88657,42.2829805 151.65396,43.0155917 C154.165999,43.5389332 156.259365,45.7367667 157.829055,49.8184957 C159.085074,53.0630121 159.713084,56.3074616 159.713084,59.3425746 C159.713084,62.0637496 159.503748,64.6802562 158.980072,67.0873594 Z" fill="#FFFFFF"> </path> </g> </g>
    
    </svg>

  )
}

const MySidebar: React.FC<SidebarProps> = (props): JSX.Element => {
  const [collapseShow, setCollapseShow] = React.useState("hidden");
  const [menuItems, setMenuItems] = React.useState(menuItemsBase);
  useEffect(() => {
    if(Object.keys(props.profile).length > 0){
      const enabledMenuItems: MenuItem[] = [];
      if (props.profile.canGenerateInvoices){
        enabledMenuItems.push(invoiceMenuItem);
      }
      if (props.profile.wooCommerceEnabled) {
        enabledMenuItems.push(wooCommerceMenuItem);
      }
      if (props.profile.shopifyEnabled) {
        enabledMenuItems.push(shopifyMenuItem);
      }
      setMenuItems((prevMenuItems) => [...prevMenuItems, ...enabledMenuItems ]);
    }
  }, [props.profile?.status])

  return (
    <section className="mx-4 md:col-span-1 px-4 bg-primary-inabit-coffe rounded-3xl md:flex-col md:items-stretch items-center justify-between w-full mx-auto px-4">
      <div className="grid grid-cols-3 lg:grid-cols-1 w-full">
        <div className="grid justify-items-start">
          <button
            className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
            type="button"
            onClick={() => setCollapseShow("bg-white m-2 py-3 px-6")}
          >
            <i className="fas fa-bars text-white"></i>
          </button>
        </div>
        <div className="grid">
          <Link
            className="md:block text-left md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
            to="/"
          >
            <img src={logo} alt="logo" className='w-56 m-auto' />
          </Link>
          <hr className="hidden lg:block mt-1 mb-4 md:min-w-full " />
        </div>
        <div className="grid justify-items-end mx-2">
          <ul className="md:hidden items-center flex flex-wrap list-none">
            <li className="inline-block relative">
              {/* <NotificationDropdown /> */}
            </li>
            <li className="inline-block relative">
              {/* <UserDropdown /> */}
            </li>
          </ul>
        </div>
      </div>

      {/* Collapse */}
      <div
        className={
          "sm:bg-white min-h-screen lg:bg-transparent md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-4 md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded " +
          collapseShow
        }
      >
        {/* Collapse header */}
        <div className="md:min-w-full md:hidden block p-1 mb-4 bg-primary-inabit-coffe rounded-3xl text-white">
          <div className="grid grid-flow-col-dense grid-cols-2">
            <div className="grid">
              <Link
                className="md:block text-left md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
                to="/"
              >
                <img src={logo} alt="logo" className='w-28 m-auto' />
              </Link>
            </div>
            <div className="grid justify-items-end">
              <button
                type="button"
                className="cursor-pointer opacity-60 md:hidden px-3 leading-none  mx-4"
                onClick={() => setCollapseShow("hidden")}
              >
                <i className="fas fa-times text-white text-2xl"></i>
              </button>
            </div>
          </div>
        </div>

        <ul className="md:flex-col md:min-w-full flex flex-col list-none md:mb-4">
          {
            menuItems.map((item, i) => (
              <li className={
                "items-center mb-4 rounded-3xl px-4 " +
                (window.location.href.indexOf(item.path) !== -1
                  ? "bg-primary-inabit-red .shadow-inner-xl"
                  : "hover:bg-primary-inabit-red")
              } key={i}>
                <a
                  className={"text-sm uppercase py-6 font-bold block sm:text-black md:text-white hover:text-white "}
                  href={item.path}
                >
                  <div className="flex items-center">
                    <div className="flex-initial">
                      {item.svg}
                    </div>
                    <div className="flex-initial ">
                      {" "}{item.name}
                    </div>
                  </div>
                </a>
              </li>
            )
            )
          }
        </ul>
        <div className="mt-auto py-4 text-center">
          <span className="text-white text-xs opacity-75 font-semibold tracking-wider">
            v{API_VERSION}
          </span>
        </div>
      </div>
    </section >
  );
};

export default MySidebar
